import { useTranslation } from "react-i18next";
import TitleDescription from "../../../../components/newMotorPolicy/titleDescription/titleDescription";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import BottomLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/bottomLayout";
import { cancellationReasons } from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/data";
import PolicyCancellationMotorLayout from "../../../motorInsurancePages/policyOverview/managePolicy/policyCancellationFlow/policyCancellationMotorLayout";
import AlertComponent from "../../../motorInsurancePages/transferPolicyFlow/alertComponent";

const CyberSecurityConfirmCancellationPage = ({
  handleNavigationToPolicyOverview,
  confirmedCancellation,
  selectedReasonOut,
}) => {
  const translate = useLanguageTranslate();
  const { t } = useTranslation();

  const continueClickHandler = () => {
    confirmedCancellation();
  };

  // Get the selected reason label
  const selectedReasonObj = cancellationReasons.find(
    (reason) => reason.label === selectedReasonOut
  );

  return (
    <PolicyCancellationMotorLayout
      is_hide_back_btn={true}
      show_close_btn={true}
      handleCloseBtnClick={handleNavigationToPolicyOverview}
      btn_onClick={continueClickHandler}
      btn_disabled={false}
      btn_label={translate("Confirm Cancellation", "تأكيد الإلغاء")}
      CancellationAdditionalComponent={
        <BottomLayout
          className="btvk"
          btn_onClick={continueClickHandler}
          btn_disabled={false}
          btn_label={translate("Confirm Cancellation", "تأكيد الإلغاء")}
          handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
        />
      }
    >
      <div className="flex flex-col items-center mx-auto max-w-lg max767:p-5 max767:mt-0 max767:pt-0 max767:pb-[50px]">
        <div className="flex justify-center items-center w-full">
          <div className=" p-0 w-full ">
            <TitleDescription
              title={translate(
                "Confirm Policy Cancellation",
                "تأكيد إلغاء السياسة"
              )}
              description={translate(
                "Please confirm that you want to proceed with cancelling your cyber security policy.",
                "يرجى تأكيد رغبتك في المتابعة مع إلغاء وثيقة الأمان السيبراني."
              )}
            />

            <AlertComponent
              className="mb-6 mt-6"
              title={translate(
                "Important: This action will submit a cancellation request for your cyber security insurance policy. The cancellation is subject to our terms and conditions and approval process.",
                "هام: سيؤدي هذا الإجراء إلى تقديم طلب إلغاء لوثيقة تأمين الأمان السيبراني. الإلغاء يخضع لشروطنا وأحكامنا وعملية الموافقة."
              )}
            />

            {/* Selected Reason Display */}
            {selectedReasonObj && (
              <div className="bg-[#F6F8F9] rounded-lg p-4 mb-6">
                <h4 className="text-[#1A2024] font-medium mb-2">
                  {translate("Cancellation Reason:", "سبب الإلغاء:")}
                </h4>
                <p className="text-[#5B6871]">
                  {translate(
                    selectedReasonObj.label,
                    selectedReasonObj.label_ar
                  )}
                </p>
              </div>
            )}

            {/* Final confirmation message */}
            <div className="bg-white border border-[#DDE2E4] rounded-lg p-4">
              <p className="text-[#1A2024] text-center">
                {translate(
                  "By clicking 'Confirm Cancellation', you acknowledge that you want to cancel your cyber security insurance policy.",
                  "بالنقر على 'تأكيد الإلغاء'، فإنك تقر برغبتك في إلغاء وثيقة تأمين الأمان السيبراني."
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PolicyCancellationMotorLayout>
  );
};

export default CyberSecurityConfirmCancellationPage;
